module.exports = __webpack_public_path__ + "static/img/5234_phase_function_Paper_Points.2725d6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5234_phase_function_Paper_Points.png
// module id = pB+R
// module chunks = 0